import { useState } from "react";
import { View } from "react-native";
import PillButton from "src/components/PillButton";
import log from "src/helpers/log";
import useDevice from "src/hooks/useDevice";
import useEditCoverGalleryStore from "src/screens/(internal)/EditCoverGalleryModal/hooks/useEditCoverGalleryStore";
import { paddingLarge, paddingXXL } from "src/styles/spacing";
import { Text, useSafeArea } from "src/swsh-native";
import handleEditCoverSave from "./helpers/handleEditCoverSave";

const EditCoverHeader = () => {
	const safeArea = useSafeArea();
	const { device } = useDevice();
	const horizontalMargin = device === "desktop" ? paddingXXL : paddingLarge;
	const [chooseLoading, setChooseLoading] = useState(false);
	const onClose = useEditCoverGalleryStore((state) => state.onClose);
	const selection = useEditCoverGalleryStore((state) => state.selection);

	return (
		<View
			style={{
				width: "100%",
				alignItems: "center",
				justifyContent: "center",
				marginTop: safeArea.top,
				height: 60,
			}}
		>
			<PillButton
				onPress={onClose}
				containerStyle={{
					position: "absolute",
					left: horizontalMargin,
				}}
			>
				Cancel
			</PillButton>
			<Text semibold>Edit cover</Text>
			<PillButton
				loading={chooseLoading}
				disabled={!selection || selection.variant === "Initial"}
				containerStyle={{
					position: "absolute",
					right: horizontalMargin,
				}}
				onPress={async () => {
					if (!selection) return;
					setChooseLoading(true);
					try {
						await handleEditCoverSave(selection);
						onClose();
					} catch (err) {
						log.error({ err }, "Failed to save cover");
					} finally {
						setChooseLoading(false);
					}
				}}
			>
				Choose
			</PillButton>
		</View>
	);
};
export default EditCoverHeader;
